const SittingLocations = [
  'Driver\'s Seat',
  'Passenger\'s Seat',
  'Rear Left Seat',
  'Rear Middle Seat',
  'Rear Right Seat'
]

export default SittingLocations
